import React, { useEffect, useRef, useState } from "react";
import styles from "./PricesAndLiquidity.module.css";

import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';

import { useDispatch, useSelector } from "react-redux";
import Chart from "../../../../components/Chart/Chart";
import TrendTable from "../../../../components/TrendTable/TrendTable";

const PricesAndLiquidity = () => {
  const dispatch = useDispatch();
  const stepperRef = useRef(null);


  const [isLoading, setIsLoading] = useState(true);
  const notification = useSelector((state) => state.ui.notification);

  useEffect(() => {
    if (
      notification !== null &&
      notification !== undefined &&
      ((notification.status !== undefined &&
        notification.status !== null &&
        notification.status === "error") ||
        notification.status === "warning")
    ) {
      setTimeout(() => {
        window.location.href = "/";
      }, 1000);
    }
  }, [notification]);

  const data = [
    { fecha: '2023-01-01', ventas: -100, dinero: 200, e: 500, limiteSup: 1000, limiteInf: 100, tendencia: 500 },
    { fecha: '2023-02-01', ventas: 110, dinero: 210, e: 510, limiteSup: 1000, limiteInf: 100, tendencia: 800 },
    { fecha: '2023-03-01', ventas: 105, dinero: 190, e: 495, limiteSup: 1000, limiteInf: 100, tendencia: 900 },
    { fecha: '2023-04-01', ventas: 115, dinero: 230, e: 520, limiteSup: 1000, limiteInf: 100, tendencia: 1 },
    { fecha: '2023-05-01', ventas: 120, dinero: 240, e: 530, limiteSup: 1000, limiteInf: 100, tendencia: 1 },
    { fecha: '2023-06-01', ventas: 130, dinero: 235, e: 540, limiteSup: 1000, limiteInf: 100, tendencia: 1 },
    { fecha: '2023-07-01', ventas: 128, dinero: 250, e: 560, limiteSup: 1000, limiteInf: 100, tendencia: 1 },
    { fecha: '2023-08-01', ventas: 135, dinero: 260, e: 570, limiteSup: 1000, limiteInf: 100, tendencia: 1 },
    { fecha: '2023-09-01', ventas: 140, dinero: 270, e: 580, limiteSup: 1000, limiteInf: 100, tendencia: 1 },
    { fecha: '2023-10-01', ventas: 145, dinero: 275, e: 590, limiteSup: 1000, limiteInf: 100, tendencia: 1 },
    { fecha: '2023-11-01', ventas: 150, dinero: 280, e: 600, limiteSup: 1000, limiteInf: 100, tendencia: 1 },
    { fecha: '2023-12-01', ventas: 155, dinero: 285, e: 610, limiteSup: 1000, limiteInf: 100, tendencia: 1 },
    { fecha: '2024-01-01', ventas: 160, dinero: 290, e: 620, limiteSup: 1000, limiteInf: 100, tendencia: 1 },
    { fecha: '2024-02-01', ventas: 162, dinero: 295, e: 630, limiteSup: 1000, limiteInf: 100, tendencia: 1 },
    { fecha: '2024-03-01', ventas: 165, dinero: 300, e: 640, limiteSup: 1000, limiteInf: 100, tendencia: 1 },
    { fecha: '2024-04-01', ventas: 170, dinero: 310, e: 650, limiteSup: 1000, limiteInf: 100, tendencia: 1 },
    { fecha: '2024-05-01', ventas: 175, dinero: 320, e: 660, limiteSup: 1000, limiteInf: 100, tendencia: 1 },
    { fecha: '2024-06-01', ventas: 180, dinero: 330, e: 670, limiteSup: 1000, limiteInf: 100, tendencia: 1 },
  ];
  const columns = [
    {
      field: "fecha",
      header: "Fecha",
      filterMatchMode: "contains",
    },
    {
      field: "ventas",
      header: "Ventas",
      filterMatchMode: "contains",
    },
    {
      field: "dinero",
      header: "Dinero",
      filterMatchMode: "contains",
    },
    {
      field: "e",
      header: "E",
      filterMatchMode: "contains",
    },
    {
      field: "limiteSup",
      header: "Límite Superior",
      filterMatchMode: "contains",
    },
    {
      field: "limiteInf",
      header: "Límite Inferior",
      filterMatchMode: "contains",
    },
    {
      field: "tendencia",
      header: "Tendencia",
      filterMatchMode: "contains",

    },
  ];

  

  const showLegend = data && data.length > 1;

  return (
    <div>

      <div className="relative z-0">
        <div className={styles.header}>
          <i
            onClick={() => (window.location.href = "/")}
            className={`pi pi-arrow-left ${styles.goBackIcon} mb-3`}
          ></i>
          <h1 className={styles.menuTitle}>Precios y Liquidez</h1>
          <h2 className={styles.menuSubtitle}>Precios y Liquidez</h2>
          <TrendTable data={data} columns={columns} actions={[]} />
          <Stepper ref={stepperRef}>
            <StepperPanel header="Matriz de Precios y Liquidez">
            </StepperPanel>
            <StepperPanel header="Gráfica de Precios y Liquidez">
              <Chart
                data={data}
                title="Mi Gráfica"
                showDataZoom={true}
                height="400px"
                smooth={true}
                showSymbols={false}
                areaStyle={true}
                showLegend={showLegend}
                lowerLimitColumn={"limiteInf"}
                upperLimitColumn={"limiteSup"}
                // lineColumns={"ventas"}
                barColumns={["ventas"]}
                chartType="line"
                // showLabels
                // groupByQuarter
              />
            </StepperPanel>
          </Stepper>
        </div>
      </div>
    </div>
  );
};

export default PricesAndLiquidity;
